// extracted by mini-css-extract-plugin
export var container = "_ko-0";
export var segment = "_ko-2";
export var segmentActive = "_ko-3";
export var track = "_ko-1";